import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserAuthService } from '../services/user-auth.service';
import { ProfileService } from '../services/profile.service';


/**
 * A Sanlam Online sign-in gives a real token before the customer has accepted consent, confirmed their basic info or
 * answered the security questions. The portal is only for customers whose account the consent journey has activated,
 * so anyone who types /portal/... straight after signing in goes back to /scs-consent. The server's answer decides,
 * not anything the browser stores.
 */
@Injectable({
  providedIn: 'root'
})
export class SolJourneyGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly userAuthService: UserAuthService,
    private readonly profileService: ProfileService
  ) { }

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.userAuthService.signedInThroughSolPolicy()) {
      return of(true);
    }

    return this.profileService.userProfile().pipe(
      map((profile: any) => profile?.isActive ? true : this.router.parseUrl('/scs-consent')),
      catchError(() => of(this.router.parseUrl('/scs-consent')))
    );
  }
}
